import { Config } from 'config/envConfig';
import React, { useState } from 'react';
import axios from 'axios';
import {
    faCheckCircle,
    faCircleXmark,
} from '@fortawesome/free-solid-svg-icons';
import {
    alert,
    AlertType,
    Button,
    Input,
    LoadingView,
    TextArea,
} from '@quyva/shared-ui';
import { getUrl } from '../pdfDisplay/utils';

const EditAgentView = ({
    agentData,
    setEditMode,
    getAgentList,
    agentList,
    user,
}) => {
    const [agentName, setAgentName] = useState(agentData.name);
    const [creationString, setCreationString] = useState(
        agentData.creationString || ''
    );
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!agentName) {
            alert(AlertType.WARNING, 'Agent name cannot be empty.');
            return;
        }

        // --- THIS IS THE REAL API LOGIC BRANCH ---
        try {
            setIsLoading(true);
            const dynamicUrl = getUrl(
                `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/agent_manager/update_agent`
            );
            const formData = new URLSearchParams();
            formData.append('agentId', agentData.id);
            formData.append('name', agentName);
            formData.append('creationString', creationString);
            formData.append('agentDescription', agentData.description);
            formData.append('ownerId', user.email);
            const encodedToken = encodeURIComponent(user.token);
            await axios.post(dynamicUrl, formData, {
                headers: {
                    Authorization: encodedToken,
                },
            });
            alert(AlertType.SUCCESS, `${agentName} updated successfully!`);
            await getAgentList(); // Re-fetch data in the main view
            setEditMode(null); // Close the modal
        } catch (err) {
            const errorMessage =
                err.response?.data?.detail || `Error editing ${agentName}.`;
            alert(AlertType.ERROR, errorMessage, false);
        } finally {
            setIsLoading(false);
        }
    };

    const originalCreationString = agentData.creationString || '';
    
    const isUnchanged =
        creationString === originalCreationString;


    return (
        <div className='w-[60vw] min-w-[500px] flex-col px-6 py-6 rounded-xl bg-backgrounds-slate text-texts-secondary300'>
            {isLoading ? (
                <div className='w-full h-48 flex justify-center items-center'>
                    <LoadingView
                        loadingText={'Updating Agent...'}
                        inLine={false}
                    />
                </div>
            ) : (
                <form>
                    <div className='mb-5'>
                        <label className='font-semibold mb-2 block'>
                            Agent Name
                        </label>
                        <Input
                            type='text'
                            placeholder='Enter agent name'
                            value={agentName}
                            maxLength={60}
                            onChange={(e) => setAgentName(e.target.value)}
                            autoFocus
                            disabled={true}
                        />
                    </div>
                    <div className='mb-5'>
                        <label className='font-semibold mb-2 block'>
                            Description
                        </label>
                        <TextArea
                            value={
                                agentData.description ||
                                'No description available.'
                            }
                            rows={4}
                            className='p-2'
                            resize={'none'}
                            disabled={true}
                        />
                    </div>
                    <div className='mb-5'>
                        <label className='font-semibold mb-2 block'>
                            Agent Creation String
                        </label>
                        <TextArea
                            placeholder='Enter agent creation string'
                            value={creationString}
                            onChange={(e) => setCreationString(e.target.value)}
                            rows={10}
                            className='p-2 h-32'
                            resize={'none'}
                        />
                    </div>
                    <div className='flex items-center justify-between w-full mt-4'>
                        <Button
                            type='danger'
                            icon={faCircleXmark}
                            className='w-1/3'
                            text={'Cancel'}
                            onClick={() => setEditMode(null)}
                        />
                        <Button
                            type='success'
                            icon={faCheckCircle}
                            className='w-1/3'
                            text={'Update'}
                            onClick={handleSubmit}
                            disabled={isUnchanged}
                        />
                    </div>
                </form>
            )}
        </div>
    );
};

export default EditAgentView;
